import { motion } from "framer-motion";

// Masked line-by-line reveal (words slide up from an overflow-hidden container)
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll-triggered fade + drift up
export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "", variant = "light" }) => (
  <span className={`text-xs uppercase tracking-[0.25em] ${variant === "dark" ? "text-white/50" : "text-black/50"} ${className}`}>
    {children}
  </span>
);
